export const BOOTH_TIPS = {
  first_open: {
    pose: 'thinking',
    line: 'Mumble the flow over the beat first. Words come second.',
  },
  crowded: {
    pose: 'confused',
    line: "That bar's crowded. Cut a word or split it in two.",
  },
  hook_rhyme: {
    pose: 'thinking',
    line: 'Hooks hit harder when the last words rhyme. Tap the last word for options.',
  },
  first_beat: {
    pose: 'happy',
    line: 'Find the pocket. Tap the beat on your desk, then write to it.',
  },
  keep_writing: {
    pose: 'writing',
    line: 'Verse 2 picks up where Verse 1 left off. Then bring the hook back and land it with an outro.',
  },
  first_copy: {
    pose: 'satisfied',
    line: 'Read the flow notes before you hit record.',
  },
};
